import {IntermediatePart} from "../../intermediatePart";
import Appliance from "../../parts/appliance";

export default class Handle extends IntermediatePart {
  constructor(isChild, partNumber = 0) {
    super(isChild);
    this.partNumber = partNumber;
    this.partId = 'handle';
    this.partName = 'Handle';
    this.translateId = "visualizer.kitchen.cabinet.handle";
    this.hasAdditionalParts = true;
    this.layerPriority = 8;
  }

  load(dbFeature) {
    const partNumber = (dbFeature.metaData["Part"] && +dbFeature.metaData["Part"][0]) === 0 ? 1 : 2;
    return super.load_(dbFeature, new Handle(false, partNumber), true, partNumber === 1 ? 'features' : 'featuresParts');
  }

  getActiveFeaturePartsAccordingToActiveFeature(fromFeature = this.activeFeature, activeFeatureConditions = []) {
    let activeFeatureParts = [];
    if (fromFeature && fromFeature.partNumber) {
      const name1 = fromFeature.getSplittedFeatureName();
      // console.log("name1", name1);
      let arrayOfConditions = activeFeatureConditions.length
        ? activeFeatureConditions
        : this.getActiveFeatureConditions(fromFeature);

      const cabinetParent = this.getParent();
      const applianceParent = cabinetParent.layout.parts[Appliance.id];

      // part 0 - показываем всегда
      // part 1 - только если выключен холодильник
      // part 2 - показываем всегда, но зависит от MountType part 2 нижних кабинетов (S, U или ST, FM, SM)
      // part 3 - если включен part 3 нижних кабинетов (это срабатывает при выключенной посудомойке)
      // part 4 - если включен part 4 нижних кабинетов (это срабатывает при выключенной плите)
      // part 5 - если включен part 2 верхних кабинетов (это срабатывает при выключенной вытяжке)
      // part 6 - если включен fridge и матчим по его метадате Width и Height, так же как и кабинеты
      activeFeatureParts = this.featuresParts.filter((feature) => {
        if (feature.metaData["Part"] && feature.metaData["Part"].includes("1")
          && (!applianceParent || !applianceParent.fridge || !applianceParent.fridge.activeFeature && applianceParent.fridge.disabled)) {
          return false
        }
        if (feature.metaData["Part"] && feature.metaData["Part"].includes("2")) {
          if (cabinetParent && cabinetParent.bottomCabinet && cabinetParent.bottomCabinet.activeFeatureParts) {
            const part2 = cabinetParent.bottomCabinet.activeFeatureParts.find(featuresPart => featuresPart.metaData["Part"].includes("2"));
            if (part2) {
              return name1 === feature.getSplittedFeatureName() && feature.matchesMetaForArrayOfConditions([
                ...arrayOfConditions,
                {propName: "MountType", propValue: part2.metaData["MountType"]}
              ])
            }
          }
          return false
        }
        if (feature.metaData["Part"] && feature.metaData["Part"].includes("3")
          && applianceParent && applianceParent.dishwasher && !applianceParent.dishwasher.disabled && applianceParent.dishwasher.activeFeature) {
          return false
        }
        if (feature.metaData["Part"] && feature.metaData["Part"].includes("4")
          && applianceParent && applianceParent.stove && !applianceParent.stove.disabled && applianceParent.stove.activeFeature) {
          return false
        }
        if (feature.metaData["Part"] && feature.metaData["Part"].includes("5")
          && applianceParent && applianceParent.hood && !applianceParent.hood.disabled && applianceParent.hood.activeFeature) {
          return false
        }
        if (feature.metaData["Part"] && feature.metaData["Part"].includes("6")) { // 6 is fridge related
          if (!applianceParent || !applianceParent.fridge || applianceParent.fridge.disabled || !applianceParent.fridge.activeFeature) {
            return false
          }
          const fridgeConditions = applianceParent.fridge.getFridgeWidthAndHeightConditions();
          return name1 === feature.getSplittedFeatureName() && feature.matchesMetaForArrayOfConditions([...arrayOfConditions, ...fridgeConditions])
        }
        return name1 === feature.getSplittedFeatureName() && feature.matchesMetaForArrayOfConditions(arrayOfConditions)
      });

      // console.log("this.featuresParts", this.featuresParts);
      // console.log("activeFeatureParts", activeFeatureParts);
      activeFeatureParts.forEach((activeFeaturePart) => {
        activeFeaturePart.disabled = this.disabled
      });
    }
    return activeFeatureParts
  }

}
